import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { WithTranslation, withTranslation } from 'react-i18next';
import { ICPOInternalTransfersGridProps } from '../../types/propTypes/propTypes';
import { Common } from '../../utils/constants';
import { Can } from '../../ability';
import { CPOInternalTransfersGrid } from './CPOInternalTransfersGrid';
import { companyNameReplace } from '../../utils';

export class CPOInternalTransfers extends Component<ICPOInternalTransfersGridProps & WithTranslation> {
    render() {
        return (
            <>
                <Helmet>
                    <title>{companyNameReplace(this.props.t('CPOInternalTransfers.title'))}</title>
                </Helmet>
                <Can I={Common.Actions.CAN_VIEW} a={Common.Modules.CPOS.CPOS_INTERNAL_TRANSFER}>
                    <CPOInternalTransfersGrid {...this.props} />
                </Can>
            </>
        );
    }
}

export default withTranslation()(CPOInternalTransfers);
